import { SubscriptionInterval } from '../../../../types/firm';
import plans from './plans.json';

export const STEP = 50;

type Plan = {
    name: string;
    includedEntities: number;
    price: number;
    priceAnnual: number;
    additionalEntitiesCost: number;
};

// Pre sort plans by included entities
const sortedPlans = Object.values(plans).sort((a, b) => (a.includedEntities > b.includedEntities ? 1 : -1));
export function calculatePlan(activeEntities: number): Plan {
    // First match plan based on base entity count
    const initialPlanIdx = sortedPlans.findIndex((p) => activeEntities <= p.includedEntities);
    const initialPlan = sortedPlans[initialPlanIdx] ?? sortedPlans.at(-1);

    // If the current active entity count is lower than the plans base count check if the prior plan is worth it.
    if (activeEntities < initialPlan.includedEntities) {
        const lowerPlan = sortedPlans[initialPlanIdx - 1];
        if (lowerPlan) {
            // We can't charge more than the initial matches base price
            const priceCeil = initialPlan.price;
            // How many more entities has the user selected then the lower plans included amount
            const additionalEntities = activeEntities - lowerPlan.includedEntities;
            // How much is the user paying on this lower tier for the extra entities
            const additionalCost = (additionalEntities / STEP) * lowerPlan.additionalEntitiesCost;

            // If the user is paying less than the initial plans base price return the lower plan
            if (lowerPlan.price + additionalCost < priceCeil) {
                return lowerPlan;
            }
            // It's better if the user selects the initial plan, getting more entities included
            else {
                return initialPlan;
            }
        }
    }
    return initialPlan;
}

export function formatCost(interval: SubscriptionInterval, activeEntities: number, plan: Plan): string {
    const additionalSlots = (Math.max(activeEntities, plan.includedEntities) - plan.includedEntities) / STEP;

    if (interval === 'MONTHLY') {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'aud',
        }).format(plan.price + additionalSlots * plan.additionalEntitiesCost);
    }

    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'aud',
    }).format(plan.priceAnnual + additionalSlots * (plan.additionalEntitiesCost * 12));
}
